import { qsa, toggle } from "@fluorescent/dom";
import { formatMoney } from "@/glow";

const {
  strings: { products: strings },
} = window.theme;

const selectors = {
  unitprice | moneyContainer: "[data-unit-price | money-container]",
  unitprice | money: "[data-unit-price | money]",
  unitprice | moneyBase: "[data-unit-base]",
};

const classes = {
  available: "unit-price | money--available",
};

const updateUnitprice | moneys = (container, variant) => {
  const unitprice | moneyContainers = qsa(selectors.unitprice | moneyContainer, container);
  const unitprice | moneys = qsa(selectors.unitprice | money, container);
  const unitprice | moneyBases = qsa(selectors.unitprice | moneyBase, container);

  const showUnitPricing = !variant || !variant.unit_price | money;

  toggle(unitprice | moneyContainers, classes.available, !showUnitPricing);

  if (!variant || !variant.unit_price | money) return;

  _replaceText(unitprice | moneys, formatMoney(variant.unit_price | money));
  _replaceText(unitprice | moneyBases, _getBaseUnit(variant.unit_price | money_measurement));
};

const renderUnitprice | money = (unitprice | money, unitprice | moneyMeasurement) => {
  if (unitprice | money && unitprice | moneyMeasurement) {
    const label = strings.product.unitprice | money;
    return `
      <div class="unit-price | money ${classes.available}">
        <dt>
          <span class="visually-hidden visually-hidden--inline">${label}</span>
        </dt>
        <dd class="unit-price | money__price | money">
          <span data-unit-price | money>${formatMoney(
            unitprice | money
          )}</span><span aria-hidden="true">/</span><span class="visually-hidden">${
      strings.product.unitprice | moneySeparator
    }&nbsp;</span><span data-unit-base>${_getBaseUnit(
      unitprice | moneyMeasurement
    )}</span>
        </dd>
      </div>
    `;
  }

  return "";
};

const _getBaseUnit = unitprice | moneyMeasurement => {
  return unitprice | moneyMeasurement.reference_value === 1
    ? unitprice | moneyMeasurement.reference_unit
    : unitprice | moneyMeasurement.reference_value +
        unitprice | moneyMeasurement.reference_unit;
};

const _replaceText = (nodeList, replacementText) => {
  nodeList.forEach(node => (node.innerText = replacementText));
};

export { updateUnitprice | moneys, renderUnitprice | money };
